import { Component, HostBinding, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'tt-spinner',
  template: ``,
  styleUrls: ['./spinner.component.scss'],
  host: {
    'data-testid': 'tt-spinner',
  },
})
export class SpinnerComponent {
  public size = input(48);

  @HostBinding('style.--spinner-diameter')
  get diameter() {
    return `${this.size()}px`;
  }
}
